import React, { useState } from 'react';
import { Card, Badge, Button, Form, ListGroup } from 'react-bootstrap';

const NotificationCenter = ({ notifications }) => {
  const [filter, setFilter] = useState('all');
  // const [showRead, setShowRead] = useState(true);

  const filteredNotifications = notifications.filter(notification => {
    if (filter !== 'all' && notification.type !== filter) return false;
    return true;
  });
 
  const notificationTypes = ['all', 'success', 'warning', 'danger', 'info'];

  const getNotificationIcon = (type) => {
    const icons = {
      success: 'fas fa-check-circle',
      warning: 'fas fa-exclamation-triangle',
      danger: 'fas fa-exclamation-circle',
      info: 'fas fa-info-circle'
    };
    return icons[type] || 'fas fa-bell';
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - notificationTime) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return notificationTime.toLocaleDateString('en-IN');
  };

  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            Notifications 
            <Badge bg="secondary" className="ms-2">
              {filteredNotifications.length}
            </Badge>
          </h5>
          <div className="d-flex gap-2">
            <Form.Select 
              size="sm" 
              value={filter} 
              onChange={(e) => setFilter(e.target.value)}
              style={{ width: 'auto' }}
            >
              {notificationTypes.map(type => (
                <option key={type} value={type}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      </Card.Header>
      
      <Card.Body className="p-0">
        {filteredNotifications.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-bell-slash fa-2x text-muted mb-2"></i>
            <p className="text-muted mb-0">No notifications found</p>
          </div>
        ) : (
          <ListGroup variant="flush">
            {filteredNotifications.map((notification) => (
              <ListGroup.Item 
                key={notification.id}
                className="border-0 py-3"
              >
                <div className="d-flex align-items-start">
                  <div className={`me-3 text-${notification.type}`}>
                    <i className={getNotificationIcon(notification.type)}></i>
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-1">
                      <h6 className="mb-1">{notification.title}</h6>
                      <small className="text-muted">
                        {formatTimestamp(notification.timestamp)}
                      </small>
                    </div>
                    <p className="mb-2 text-muted small">
                      {notification.message}
                    </p>
                    <Badge bg={notification.type} className="small">
                      {notification.type.toUpperCase()}
                    </Badge>
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Card.Body>
      
      {filteredNotifications.length > 0 && (
        <Card.Footer className="bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <small className="text-muted">
              Showing {filteredNotifications.length} notification(s)
            </small>
            <Button variant="outline-secondary" size="sm">
              Mark All as Read
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};

export default NotificationCenter;